export default "__VITE_ASSET__f48fcf86__"